import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import "./contact.css";
import axios from "axios";
import { toast } from "react-toastify";
import { api_url } from "../url";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });

  // handle change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${api_url}/api/v1/contactus/add/contact`,
        formData,
      );

      toast.success("Query submitted successfully!");

      setFormData({ name: "", mobile: "", email: "", message: "" });
    } catch (err) {
      toast.error(err.response?.data?.message || "Submission failed");
      console.error(err);
    }
  };

  return (
    <>
      {/* 🔹 Premium Banner */}
      <section className="contact-banner">
        <div className="banner-overlay"></div>
        <Container>
          <div className="banner-content">
            <h1>Contact Us</h1>
            <p>We would love to hear from you</p>
          </div>
        </Container>
      </section>

      {/* 🔹 Contact Section */}
      <Container className="contact-section">
        <Row className="g-4">
          {/* Left Form */}
          <Col md={8}>
            <Card className="contact-card">
              <h3 className="mb-4">Get in Touch</h3>

              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        name="name"
                        type="text"
                        placeholder="Enter your name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label>Mobile</Form.Label>
                      <Form.Control
                        name="mobile"
                        type="mobile"
                        placeholder="Enter your mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="mb-4">
                  <Form.Group>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      name="email"
                      type="email"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    name="message"
                    as="textarea"
                    rows={5}
                    placeholder="Write your message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Button className="contact-btn" type="submit">
                  Send Message
                </Button>
              </Form>
            </Card>
          </Col>

          {/* Right Info */}
          <Col md={4}>
            <Card className="info-card">
              <h4>Contact Information</h4>

              <div className="info-item">
                <span>Email</span>
                <p>info@icsaj.com</p>
              </div>

              {/* <div className="info-item">
                <span>Phone</span>
                <p>+91 81719-74067</p>
              </div> */}

              <div className="info-item">
                <span>Address</span>
                <p>
                  {/* Office No.101, Himland House, Commercial Complex, */}
                  Karampura, Delhi-110015,
                  {/* India 8171974067 */}
                </p>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Contact;
